export const getInitialPagination = (sortBy) => {
    let bookmark = {
        pageIndex: 1,
        pageSize: 10,
    };
    if (sortBy) {
        bookmark.sortBy = sortBy;
    }
    return bookmark;
};
